import { render, staticRenderFns } from "./TemplatewhatsappHome.vue?vue&type=template&id=20df1f6a&scoped=true"
import script from "./TemplatewhatsappHome.vue?vue&type=script&lang=js"
export * from "./TemplatewhatsappHome.vue?vue&type=script&lang=js"
import style0 from "./TemplatewhatsappHome.vue?vue&type=style&index=0&id=20df1f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df1f6a",
  null
  
)

export default component.exports